import { Box, Chip, ChipProps, useTheme } from '@mui/material'

export const FilterChip = (props: ChipProps) => {
  const theme = useTheme()

  return (
    <Box>
      <Chip
        sx={{ backgroundColor: theme.palette.background.paper, mt: 1.5 }}
        size="small"
        variant="outlined"
        {...props}
      />
    </Box>
  )
}
